export const FF_TEST_HISTORY = 'hide-test-history';
export const FF__SCENARIO_TEST_GRAPH = 'hide-scenario-time-graph';
export const FF_ARCHIVE_JOBS = 'hide-archive-job';
export const FF_ASSOCIATED_NAME = 'show-test-id-on-scenarios-tab';
export const FF_WORKFLOW = 'schedule-build';
export const FF_PARALLEL_CONCURRENCY = 'hide-parallel-concurrency-details';
export const FF_PROJECTS = 'projects';
export const FF_INSIGHTS = 'insights';
export const FF_RCA = 'hide-rca';
export const FF_CATEGORIZED_ERROR = 'hide-categorizederrors';

export const FeatureFlag = {
  [FF_TEST_HISTORY]: FF_TEST_HISTORY,
  [FF__SCENARIO_TEST_GRAPH]: FF__SCENARIO_TEST_GRAPH,
  [FF_ARCHIVE_JOBS]: FF_ARCHIVE_JOBS,
  [FF_ASSOCIATED_NAME]: FF_ASSOCIATED_NAME,
  [FF_WORKFLOW]: FF_WORKFLOW,
  [FF_PARALLEL_CONCURRENCY]: FF_PARALLEL_CONCURRENCY,
  [FF_PROJECTS]: FF_PROJECTS,
  [FF_INSIGHTS]: FF_INSIGHTS,
  [FF_RCA]: FF_RCA,
  [FF_CATEGORIZED_ERROR]: FF_CATEGORIZED_ERROR,
};
